import { REQUIRED_APP_SCOPES } from "./datadogScopes";

export const DATADOG_JS_SNIPPET = `(() => {
  const scopesToRequest = new Set(${JSON.stringify(REQUIRED_APP_SCOPES, null, 2)});

  const rows = document.querySelectorAll("tbody .druids_table_table__tr");
  rows.forEach((row) => {
    const scopeEl = row.querySelector(
      '[style*="_scopes"] .druids_layout_overflower__original'
    );
    const checkbox = row.querySelector('input.druids_form_checkbox__input');
    if (!scopeEl || !checkbox) return;

    const scopeName = scopeEl.textContent?.trim();
    if (!scopeName || !scopesToRequest.has(scopeName)) return;

    if (checkbox.checked) return;

    checkbox.click();
    console.log("Requested scope:", scopeName);
  });

  console.log(
    '%c{${REQUIRED_APP_SCOPES.length}} scopes requested successfully! Click "Save" in the UI to continue. You may now close this debugger window.',
    "color:#22c55e;font-weight:600;"
  );
})();`;
